import { yupResolver } from '@hookform/resolvers/yup'
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../../../components/Button'
import { Container, Form } from '../../../../components/commons'
import Modal from '../../../../components/Modals/Modal'
import useToast from '../../../../hooks/useToast'
import { api } from '../../../../services/api'

import {
  DocumentTypeDataForm,
  registerDocumentTypeWithDataSchema,
} from '../../../../validators/document.schemas'
import { SelectDocumentType } from '../../../../components/Modals/ModalUpload'
import MetaDataValues from './MetaDataValues'

export interface DocumentTypeIndexProps {
  reflesh: () => any
}

export interface DocumentTypeIndexHandle {
  openFormModal: (documentId?: string) => void
}

type ModalRef = React.ElementRef<typeof Modal>

const DocumentTypeIndex: React.ForwardRefRenderFunction<
  DocumentTypeIndexHandle,
  DocumentTypeIndexProps
> = ({ reflesh }, ref) => {
  const [loading, setLoading] = useState(false)

  const [documentId, setdocumentId] = useState<string>()
  const [dataPayload, setdataPayload] = useState<DocumentTypeDataForm>()

  const [isIndexFound, setIsIndexFound] = useState<string>()

  const toast = useToast()

  const modalRef = useRef<ModalRef>(null)

  const {
    setValue,
    control,
    handleSubmit,
    reset,
    getValues,
    setError,
    watch,
    formState: { errors },
  } = useForm<DocumentTypeDataForm>({
    defaultValues: {},
    resolver: yupResolver(registerDocumentTypeWithDataSchema),
  })

  const documentType = watch('documentType')
  const getDocumentTypeValues = async (documentTypeId: string) => {
    try {
      if (!documentTypeId) return
      setLoading(true)

      const { data: response } = await api.get(`/documentTypes/${documentTypeId}`)

      const fields =
        dataPayload?.documentType === documentTypeId
          ? response.metadata.map((meta: any, index: number) => ({
              ...meta,
              value: dataPayload?.metadata ? dataPayload?.metadata[index].value : '',
            }))
          : response.metadata
      setValue('metadata', fields)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const getDocumentTypes = async (documentId: string) => {
    try {
      setLoading(true)

      const { data: response } = await api.get(`/documents/${documentId}/documentType`)

      setValue('documentType', response?.documentType)

      setdataPayload(response)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const handleOpenModalCreate = () => {
    modalRef.current?.openModal()
  }

  const handleSubmitLogin = async (formData: DocumentTypeDataForm) => {
    try {
      setLoading(true)

      if (documentId) {
        formData.document = documentId
      }

      if (isIndexFound) {
        await api.put(`/documents/${documentId}`, {
          documentTypeWithData: isIndexFound,
        })
      } else {
        if (dataPayload?._id) {
          await api.put(`/documents/documentType/${dataPayload?._id}`, formData)
        } else {
          const { data: response } = await api.put(`/documents/documentType`, formData)

          await api.put(`/documents/${documentId}`, {
            documentTypeWithData: response?._id,
          })
        }
      }

      modalRef.current?.closeModal()
      reset()
      reflesh()
      toast.successToast('Indexs Atualizado com sucesso !')
    } catch (error) {
      toast.errorToast('Erro ao atualizar index !')
    } finally {
      setLoading(false)
    }
  }

  React.useImperativeHandle(ref, () => ({
    openFormModal(documentId) {
      if (documentId) {
        setdocumentId(documentId)
        getDocumentTypes(documentId)
      }
      setIsIndexFound(undefined)
      reset()
      handleOpenModalCreate()
    },
  }))

  React.useEffect(() => {
    getDocumentTypeValues(documentType)
  }, [documentType])

  return (
    <>
      <Modal title='Editar Index' ref={modalRef}>
        <Container>
          <Form onSubmit={handleSubmit(handleSubmitLogin)}>
            <SelectDocumentType menuPosition={'fixed'} control={control} />

            <MetaDataValues
              documentTypeId={documentType}
              label='Campos'
              setIsIndexFound={setIsIndexFound}
              getValues={getValues}
              isIndexFound={isIndexFound}
              setValue={setValue}
              error={errors.metadata}
              control={control}
              name='metadata'
            />

            <Button
              label='Salvar'
              loading={loading}
              type='submit'
              variantType='block'
              color='primary'
            />
          </Form>
        </Container>
      </Modal>
    </>
  )
}

export default React.forwardRef(DocumentTypeIndex)
